<template>
  <authorization permissionKey="attendance_treatment" can="read">
    <v-container fluid>
      <v-row>
        <v-col cols="auto" class="text-h3 gray--text">
          Tratamentos
        </v-col>
        <v-col cols="auto">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                small
                v-on="on"
                :attrs="attrs"
                :to="`/pacientes/${attendance.patient.id}/tratamentos`"
              >
                <v-icon>eva-file-outline</v-icon>
              </v-btn>
            </template>
            <span>Histórico</span>
          </v-tooltip>
        </v-col>

        <v-spacer />

        <authorization
          permissionKey="attendance_treatment"
          can="save"
          v-slot:default="{ authorization }"
        >
          <v-col cols="auto" v-if="authorization">
            <v-btn
              color="light-blue"
              :dark="!attendanceEsigned"
              @click="createTreatment"
              :disabled="attendanceEsigned"
            >
              Adicionar
            </v-btn>
          </v-col>
        </authorization>
      </v-row>

      <TreatmentList
        :attendance="attendance"
        :allowEdit="!attendanceEsigned"
        :allowDelete="!attendanceEsigned"
      />
    </v-container>
  </authorization>
</template>

<script>
  import TreatmentList from "@/components/treatment/list/index.vue";

  export default {
    name: "Treatments",
    props: {
      attendance: Object,
      attendanceEsigned: Boolean,
    },
    components: {
      TreatmentList,
    },
    data() {
      return {
        treatments: [],
      };
    },
    mounted() {
      this.refreshList();
    },
    apollo: {
      treatments: {
        query: require("@/graphql/treatment/treatments.gql"),
        variables() {
          return {
            attendanceId: this.attendance.id,
          };
        },
        pollInterval: 200000,
      },
    },
    methods: {
      refreshList() {
        return this.$apollo.queries.treatments.refetch();
      },
      createTreatment() {
        return this.apolloMutate({
          mutation: require("@/graphql/treatment/save_treatment.gql"),
          variables: {
            attendanceId: this.attendance.id,
          },
        }).then(({ data }) => {
          this.$router.push(
            `/prontuario/${this.attendance.id}/tratamentos/${data.saveTreatment.id}`
          );
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
